import { Button, Flex, FormControl, FormLabel, Grid, GridItem, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, useColorModeValue, useToast } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from '@apollo/client';
import { FORGOT_PASSWORD } from "../Graphql/Mutations";

export function ForgotPassword({ isOpen, onClose, onOpenLoginModal, onOpenVerificationModal }) {
    const { control, handleSubmit, formState: { errors }, trigger } = useForm();
    const [forgotQuery, forgot] = useMutation(FORGOT_PASSWORD);
    const toast = useToast();
    const lableStyle = {
        color: "#315b84",
        fontSize: "0.9rem",
        fontWeight: "500",
        lineHeight: "2"
    };
    const fieldStyle = {
        backgroundColor: "#f3f3f3",
    };
    const handleLoginModal = () => {
        onClose();
        onOpenLoginModal();
    }
    const onSubmit = (data) => {
        trigger().then(async (isValid) => {
            if (isValid) {
                try {
                    console.log("Data in Forgot modal is: ", data);
                    const forgotInput = {
                        email: data.email,
                    };
                    sessionStorage.setItem("email", data.email);
                    console.log(forgotInput);
                    await forgotQuery({ variables: forgotInput });
                }
                catch (error) {
                    console.log("Error in forgot modal: ", error);
                }
            }
        });
    };
    useEffect(() => {
        console.log("error:", forgot.error)
        console.log("loading:", forgot.loading)
        console.log("data:", forgot.data)
        if (forgot.data != undefined) {
            if (forgot?.data?.initiateResetPassword?.success) {
                toast({
                    title: 'Succeed',
                    description: 'OTP send on your email address',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                    position: "bottom-left"
                });
                onClose();
                onOpenVerificationModal();
            }
            else {
                toast({
                    title: 'Error',
                    description: forgot?.data?.initiateResetPassword?.message,
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                    position: "bottom-left"
                });
                sessionStorage.removeItem("email");
            }
        }
        if (forgot.error != undefined) {
            toast({
                title: 'error',
                description: forgot.error.message,
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: "bottom-left"
            });
            sessionStorage.removeItem("email");
        }
    }, [forgot.data, forgot.loading, forgot.error])
    return (
        <>
            <Modal
                isCentered
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent pt={6} my={12} backgroundColor={"#ececec"}>
                    <ModalCloseButton pt={10} size={"lg"} />
                    <ModalBody>
                        <Flex
                            align={'center'}
                            justify={'center'}>
                            <Stack
                                spacing={4}
                                w={'full'}
                                maxW={'md'}
                                rounded={'xl'}
                            >
                                <Text lineHeight={1.1} fontSize={"32px"} fontWeight={"500"}>
                                    Reset Password
                                </Text>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <FormControl id="email" mt={4} >
                                        <FormLabel {...lableStyle}>Enter Email Address:</FormLabel>
                                        <Controller
                                            name="email"
                                            control={control}
                                            defaultValue=""
                                            rules={{ required: "Email is required" }}
                                            render={({ field }) => (
                                                <Input {...field} {...fieldStyle} placeholder="your-email@example.com" type="email" />
                                            )}
                                        />
                                        {errors.email && <Text color="red">{errors.email.message}</Text>}
                                    </FormControl>
                                    <Button
                                        w={"100%"}
                                        mt={"25px"}
                                        color={'white'}
                                        fontWeight={"500"}
                                        _hover={{ bg: "#002B5B" }}
                                        bg={"#002B5B"}
                                        type="submit"
                                        isLoading={forgot.loading}
                                    >
                                        Reset Password
                                    </Button>
                                </form>
                            </Stack>
                        </Flex>
                    </ModalBody>
                    <ModalFooter w={"100%"} mb={"35px"}>
                        <Grid templateColumns='repeat(1, 1fr)' gap={4} justifyContent="start" w={"100%"}>
                            <GridItem col={12} >
                                <Text fontSize={"14.4px"} fontWeight={"500"} color="#315B84" cursor="pointer" onClick={handleLoginModal}>
                                    Back to Login
                                </Text>
                            </GridItem>
                        </Grid>
                    </ModalFooter>
                </ModalContent>
            </Modal >
        </>
    )
}